import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * "Sort by <option>" as text, not a field (same look as the mobile leads
 * sort, Leads.SortSelect): a muted label and the chosen option in secondary,
 * opening a menu. `options`: [{ value, label }].
 */
export default function SortSelect({ label, value, options, onChange }) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        variant="standard"
        disableUnderline
        inputProps={{ 'aria-label': label }}
        sx={{
          // Same size as the label next to it (the Select is body1 by default).
          typography: 'body2',
          color: 'secondary.main',
          '& .MuiSelect-select': { py: 0.25 },
          '& .MuiSelect-icon': { color: 'secondary.main' },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
}
